export default "__VITE_ASSET__XgiYK88L__"